<template>
    <v-container v-if="isCreating">
        <v-card>
            <h2 class="text-center">Create New Monthly Pool</h2>
            <v-progress-linear slot="progress" color="primary" indeterminate v-if="createdLoading"></v-progress-linear>
            <v-row v-else>
                <v-col cols="12" md="6" offset-md="3">
                    <v-form @submit.prevent ref="editForm" v-model="createPoolValid">
                        <v-row>

                            <v-col cols="12">
                                <v-select
                                    :items="species"
                                    item-text="SpeciesFullName"
                                    item-value="SpeciesID"
                                    v-model="newPool.SpeciesID"
                                    label="Species"
                                    :rules="[rules.selectIDRequired]"
                                ></v-select>
                            </v-col>

                            <v-col cols="12">
                                <v-select
                                    :items="types"
                                    item-text="TypeName"
                                    item-value="TypeValue"
                                    v-model="newPool.IsExternal"
                                    label="Type"
                                    :rules="[rules.selectIDRequired]"
                                ></v-select>
                            </v-col>

                            <v-col cols="12">
                                <v-menu
                                    ref="monthPickerMenu"
                                    :close-on-content-click="false"
                                    v-model="monthPickerMenu"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            clearable
                                            v-model="displayMonth"
                                            label="Pool Month"
                                            prepend-icon="event"
                                            readonly
                                            :rules="[rules.required]"
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker 
                                        v-model="newPool.PoolMonth"
                                        @input="monthPickerMenu = false"
                                        type="month"
                                    >
                                    </v-date-picker>
                                </v-menu>
                            </v-col>

                            <v-col cols="12" class="text-center">
                                <v-btn
                                    :disabled="!createPoolValid"
                                    color="accent"
                                    @click="createPool()"
                                >
                                    Create
                                </v-btn>
                            </v-col>

                        </v-row>
                    </v-form>
                </v-col>
            </v-row>
        </v-card>
    </v-container>
    <v-container v-else>
        <v-card>
            <h2 class="text-center">{{currentPool.IsClosed ? "Monthly Pool Details" : "Manage " + (currentPool.IsExternal ? "External" : "Internal") + " Monthly Pool"}}</h2>
            <v-row >
                <v-progress-linear slot="progress" color="primary" indeterminate v-if="loadingPool"></v-progress-linear>
                <v-col cols="12" md="6" offset-md="3" v-else>
                    <v-row no-gutters>
                        <v-col cols="12" md="6">
                            <v-row no-gutters>
                                <v-col cols="4" sm="3">
                                    Pool ID
                                </v-col>
                                <v-col cols="8" sm="9">
                                    {{ currentPool.Barcode }}
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col sm="0" md="6">
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-row no-gutters>
                                <v-col cols="4" sm="3">
                                    Pool Created
                                </v-col>
                                <v-col cols="8" sm="9">
                                    {{ currentPool.PoolCreatedTime | formatDate }}
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-row no-gutters>
                                <v-col cols="4" sm="3">
                                    By
                                </v-col>
                                <v-col cols="8" sm="9">
                                    {{ currentPool.PoolCreatedByEmail | formatUserName(currentPool.PoolCreatedUserFirstName, currentPool.PoolCreatedUserLastName) }}
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" md="6" v-if="currentPool.IsClosed">
                            <v-row no-gutters>
                                <v-col cols="4" sm="3">
                                    Pool Closed
                                </v-col>
                                <v-col cols="8" sm="9">
                                    {{ currentPool.PoolClosedTime | formatDate }}
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col sm="12" md="6" v-if="currentPool.IsClosed">
                            <v-row no-gutters>
                                <v-col cols="4" sm="3">
                                    By
                                </v-col>
                                <v-col cols="8" sm="9">
                                    {{ currentPool.PoolClosedByEmail | formatUserName(currentPool.PoolClosedUserFirstName, currentPool.PoolClosedUserLastName) }}
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-row no-gutters>
                                <v-col cols="4" sm="3">
                                    Species
                                </v-col>
                                <v-col cols="8" sm="9">
                                    {{ currentPool.SpeciesFullName }}
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" md="6" v-if="currentPool.IsClosed">
                            <v-row no-gutters>
                                <v-col cols="4" sm="3">
                                    Total Weight
                                </v-col>
                                <v-col cols="8" sm="9">
                                    {{ currentPool.TotalWeight }}g
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" md="6" v-if="!currentPool.IsClosed">
                            <v-row no-gutters>
                                <v-col cols="4" sm="3">
                                    Total Weight
                                </v-col>
                                <v-col cols="8" sm="9">
                                    {{ loadingPoolDetails ? "loading..." : currentPoolDetails.TotalWeight + "g" }}
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" sm="12" md="6" offset-md="6" v-if="currentPool.IsClosed">
                            <v-row no-gutters>
                                <v-col cols="4" sm="3">
                                    In Species Batch Pool?
                                </v-col>
                                <v-col cols="8" sm="9">
                                    {{ currentPool.SpeciesBatchPoolID ? "Yes" : "No" }}
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" class="text-center">
                            <v-btn
                                color="success"
                                @click="closePool()"
                                v-if="!currentPool.IsClosed"
                            >
                                Close Pool
                            </v-btn>
                            <v-btn
                                class="ml-2"
                                color="info"
                                @click="printBarcode()"
                            >
                                Print Barcode
                            </v-btn>
                            <v-btn
                                class="ml-2"
                                color="info"
                                @click="exportPool" 
                                :disabled="exporting" 
                                :loading="exporting"
                            >
                                Export
                            </v-btn>
                            <v-btn
                                class="ml-2"
                                color="info"
                                @click="print"
                            >
                                Print
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-card>
        
        <v-card v-if="!loadingPool && !currentPool.IsClosed" class="pa-0">
            <v-expansion-panels>
                <v-expansion-panel v-if="!currentPool.IsExternal">
                    <v-expansion-panel-header>
                        <div class="title text-center">Add Daily Extraction Venom</div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <v-row>
                            <v-col cols="12" md="6" offset-md="3">
                                <MonthlyPoolAddAvailableSessions :speciesID="currentPool.SpeciesID"
                                    :monthlyPoolID="currentPool.MonthlyPoolID"
                                    @sessionsAdded="reloadSessions">
                                </MonthlyPoolAddAvailableSessions>
                            </v-col>
                        </v-row>
                    </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel v-if="currentPool.IsExternal">
                    <v-expansion-panel-header>
                        <div class="title text-center">Add Externally Supplied Venom</div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <v-row >
                            <v-col cols="12" md="6" offset-md="3">
                                <v-row >
                                    <v-col sm="12">
                                        <v-select
                                            :items="suppliers"
                                            item-text="SupplierName"
                                            item-value="SupplierID"
                                            v-model="externalVenom.SupplierID"
                                            label="Supplier">
                                        </v-select>
                                    </v-col>
                                    <v-col sm="12">
                                        <v-text-field
                                            counter="45"
                                            maxlength="45"
                                            v-model="externalVenom.SupplierReferenceNumber"
                                            label="Supplier Reference Number">
                                        </v-text-field>
                                    </v-col>
                                    <v-col sm="12">
                                        <NumericEntry
                                            v-model="externalVenom.Weight"
                                            label="Weight"
                                            suffix="g"
                                            :decimalPlaces="2"
                                            :maxValue="10000">
                                        </NumericEntry>
                                    </v-col>
                                    <v-col sm="12" class="title text-center">
                                        <v-btn
                                            color="success"
                                            :loading="savingExternalVenom"
                                            :disabled="!externalVenomValid"
                                            @click="addExternalVenom()">
                                            Add External Venom
                                        </v-btn>
                                    </v-col>
                                    <v-col sm="12" v-if="savingExternalVenomError">
                                        <v-alert text type="error">{{ savingExternalVenomError }}</v-alert>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-expansion-panel-content >
                </v-expansion-panel>
            </v-expansion-panels>
        </v-card>

        <v-card v-if="!loadingPool" class="pa-0">
            <v-expansion-panels>
                <v-expansion-panel>
                    <v-expansion-panel-header>
                        <div class="title text-center">Entered Records</div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>

                        <v-data-table
                            v-if="!currentPool.IsExternal"
                            :headers="dailyExtractionHeaders"
                            :items="currentPoolDetails.DailySessions"
                            :loading="loadingPoolDetails"
                            :items-per-page.sync="dailyExtractionPagination.rowsPerPage"
                            must-sort>
                            <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                            <template  v-slot:item="props">
                                <tr :data-id="props.item.DailyExtractionSessionID">
                                    <td>{{props.item.Barcode}}</td>
                                    <td>{{props.item.SessionStartTime | formatDate}}</td>
                                    <td>{{props.item.RoomName}}</td>
                                    <td>{{props.item.RackNumber}}</td>
                                    <td>{{props.item.Weight}}g</td>
                                    <td>
                                        <v-btn
                                            color="info"
                                            @click="openSession(props.item.DailyExtractionSessionID)"
                                        >
                                            View Session
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                            <template v-if="!loadingPoolDetails" slot="no-data">
                                <v-alert outlined :value="true" type="info">
                                    No sessions added
                                </v-alert>
                            </template>
                        </v-data-table>

                        <v-data-table
                            v-if="currentPool.IsExternal"
                            :headers="externalVenomHeaders"
                            :items="currentPoolDetails.ExternalVenom"
                            :loading="loadingPoolDetails"
                            :items-per-page.sync="externalVenomPagination.rowsPerPage"
                            must-sort>
                            <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                            <template  v-slot:item="props">
                                <tr>
                                    <td>{{props.item.SupplierName+"-"+props.item.GeographicalLocationName}}</td>
                                    <td>{{props.item.SupplierReferenceNumber}}</td>
                                    <td>{{props.item.Weight}}g</td>
                                </tr>
                            </template>
                            <template v-if="!loadingPoolDetails" slot="no-data">
                                <v-alert outlined :value="true" type="info">
                                    No sessions added
                                </v-alert>
                            </template>
                        </v-data-table>

                        <DashboardPieGraph 
                            :height="graphHeight" 
                            :data="sourceLocationData" 
                            :options="sourceLocationOptions" 
                            ref="recordMakeupGraph">
                        </DashboardPieGraph>

                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-card>

        <v-card v-if="!loadingPool" class="pa-0">
            <v-expansion-panels>
                <v-expansion-panel>
                    <v-expansion-panel-header>
                        <div class="title text-center">Venom Analysis</div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <VenomAnalysis :monthlyPoolID="monthlyPoolIDInteger"></VenomAnalysis>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-card>

        <v-card v-if="!loadingPool" class="pa-0">
            <v-expansion-panels>
                <v-expansion-panel>
                    <v-expansion-panel-header>
                        <div class="title text-center">Add Other Files</div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <OtherFilesSection :monthlyPoolID="monthlyPoolID"></OtherFilesSection>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-card>

        <MonthlyPoolCloseDialog ref="closeDialog" @updated="loadMonthlyPool"></MonthlyPoolCloseDialog>
    </v-container>
</template>

<script>
import NumericEntry from "../common/NumericEntry";
import VenomAnalysis from '../venomanalysis/VenomAnalysis';
import OtherFilesSection from "./OtherFilesSection"
import MonthlyPoolCloseDialog from './MonthlyPoolCloseDialog';
import MonthlyPoolAddAvailableSessions from './MonthlyPoolAddAvailableSessions';
import DashboardPieGraph from "@/components/dashboard/DashboardPieGraph"
import util from '@/helpers/util';
import validationRules from "../../helpers/validationrules";
import * as VenomPoolingAPI from "@/services/venomPoolingAPI";
import constants from 'comunet-btg-utah-repository-shared/constants';
import exports from "@/services/export";

import moment from 'moment';

export default {
    components: {
        NumericEntry,
        VenomAnalysis,
        MonthlyPoolAddAvailableSessions,
        MonthlyPoolCloseDialog,
        DashboardPieGraph,
        OtherFilesSection
    },
    props: {
        monthlyPoolID: {
            type: [ Number, String ],
            default: null
        },
    },
    data() {
        return {
            rules: validationRules.rules,

            // Creating a pool
            newPool: {
                IsExternal: 0
            },
            createPoolValid: false,
            monthPickerMenu: false,

            // Editing/managing an existing pool
            loadingPool: false,
            currentPool: {},
            loadingPoolDetails: false,
            currentPoolDetails: {},

            //Create an external provider venom
            savingExternalVenom: false,
            savingExternalVenomError: "",
            externalVenom: { Weight: "" },

            types: [
                {
                    TypeName: "Internal",
                    TypeValue: 0
                },
                {
                    TypeName: "External",
                    TypeValue: 1
                }
            ],

            // Settings for the various grid headers/paging
            dailyExtractionHeaders: [
                {
                    text: "Barcode",
                    value: "Barcode"
                },
                {
                    text: "Session Time",
                    value: "SessionStartTime"
                },
                {
                    text: "Room Name",
                    value: "RoomName"
                },
                {
                    text: "Rack Number",
                    value: "RackNumber"
                },
                {
                    text: "Weight",
                    value: "Weight"
                },
                {
                    text: "",
                    value: ""
                }
            ],
            dailyExtractionPagination: {
                rowsPerPage: 10,
            },
            externalVenomHeaders: [
                {
                    text: "Supplier Name",
                    value: "SupplierName"
                },
                {
                    text: "Supplier Reference Number",
                    value: "SupplierReferenceNumber"
                },
                {
                    text: "Weight",
                    value: "Weight"
                }
            ],
            externalVenomPagination: {
                rowsPerPage: 10,
            },

            graphHeight: 150,
            sourceLocationData: {
                labels: [],
                datasets: [
                    {
                        label: "Location",
                        data: [],
                        backgroundColor: ['#FF6633', '#FFB399', '#FF33FF', '#FFFF99', '#00B3E6', 
                            '#E6B333', '#3366E6', '#999966', '#99FF99', '#B34D4D',
                            '#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991A', 
                            '#FF99E6', '#CCFF1A', '#FF1A66', '#E6331A', '#33FFCC',
                            '#66994D', '#B366CC', '#4D8000', '#B33300', '#CC80CC', 
                            '#66664D', '#991AFF', '#E666FF', '#4DB3FF', '#1AB399',
                            '#E666B3', '#33991A', '#CC9999', '#B3B31A', '#00E680', 
                            '#4D8066', '#809980', '#E6FF80', '#1AFF33', '#999933',
                            '#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900B3', 
                            '#E64D66', '#4DB380', '#FF4D4D', '#99E6E6', '#6666FF']
                    }
                ]
            },
            sourceLocationOptions: {},

            exporting: false
        }
    },
    computed: {
        isCreating() {
            return !(this.monthlyPoolID && this.monthlyPoolID > 0);
        },
        createdLoading() {
            return this.$store.state.speciesStore.loading
        },
        species() {
            return this.$store.state.speciesStore.species.filter(s => s.Active).sort(util.sortByField("SpeciesFullName"));
        },
        displayMonth: {
            get: function() {
                if (this.newPool && this.newPool.PoolMonth) {
                    return moment.utc(this.newPool.PoolMonth).format(constants.DATE_FORMAT_MONTH);
                }
                
                return "";
            },
            set: function(newValue) {
                this.newPool.PoolMonth = newValue;
            }
        },
        suppliers() {
      

          return this.$store.state.supplierStore.suppliers.filter(s => s.Active && s.IsVenomSupplier).map(s=>{
              
              return {
                  SupplierID: s.SupplierID,
                  SupplierName: s.SupplierName+"-"+s.GeographicalLocationName
              };
          }).sort(util.sortByField("SupplierName"))
      
      
        },
        externalVenomValid() {
            return this.externalVenom.MonthlyPoolID && this.externalVenom.MonthlyPoolID > 0 &&
                this.externalVenom.SupplierID && this.externalVenom.SupplierID > 0 &&
                this.externalVenom.SupplierReferenceNumber && this.externalVenom.SupplierReferenceNumber != "" &&
                this.externalVenom.Weight && this.externalVenom.Weight > 0;
        },
        pendingFileValid() {
            return this.pendingFileName && this.pendingFileName != "" && this.pendingFile && this.pendingFile != null;
        },
        monthlyPoolIDInteger() {
            return parseInt(this.monthlyPoolID)
        }
    },
    methods: {
        async exportPool() {
            this.exporting = true;

            await exports.exportMonthlyPool(this.monthlyPoolID);
            
            this.exporting = false;
        },
        print() {
            let routeData = this.$router.resolve({name: 'printmonthlypool', params: { monthlyPoolID: this.monthlyPoolID }});
            window.open(routeData.href, '_blank');
        },
        async createPool() {
            // Set the current time
            this.newPool.PoolCreatedTime = moment().toDate();

            var monthString = this.newPool.PoolMonth.split("-");
            delete this.newPool.PoolMonth;
            this.newPool.Month = monthString[1];
            this.newPool.Year = monthString[0];

            var result = await VenomPoolingAPI.createUpdateMonthlyPool(this.newPool);

            this.$router.replace('/monthlypoolmanagement/' + result.MonthlyPoolID);

            this.monthlyPoolID = result.MonthlyPoolID;

            this.loadMonthlyPool();
        },
        async loadMonthlyPool() {
            this.loadingPool = true;

            this.currentPool = await VenomPoolingAPI.getMonthlyPool({ monthlyPoolID: this.monthlyPoolID });

            this.externalVenom = { MonthlyPoolID: this.monthlyPoolID, Weight: "" };

            // Load the details
            this.loadMonthlyPoolDetails();

            this.loadingPool = false;
        },
        async loadMonthlyPoolDetails() {
            this.loadingPoolDetails = true;

            this.currentPoolDetails = await VenomPoolingAPI.getMonthlyPoolDetails({ monthlyPoolID: this.monthlyPoolID });


            let newLabels = [];
            let newData = [];

            var data = this.currentPoolDetails.GraphData
            for (let i=0; i< data.length; i++) {
                let datum = data[i];

                newLabels.push(datum.GeographicalLocationName);
                newData.push(datum.ContributionValue);
            }

            this.sourceLocationData.labels = newLabels;
            this.sourceLocationData.datasets[0].data = newData;

            this.loadingPoolDetails = false;
        },
        printBarcode() {
            let routeData = this.$router.resolve({name: 'printbarcode', params: { barcode: this.currentPool.Barcode }});
            window.open(routeData.href, '_blank');
        },
        async addExternalVenom() {
            this.savingExternalVenom = true;
            this.savingExternalVenomError = "";

            try {
                var response = await VenomPoolingAPI.addExternallySuppliedVenom(this.externalVenom)

                if (response.success) {
                    this.externalVenom = { MonthlyPoolID: this.monthlyPoolID, Weight: "" };
                }
            }
            catch
            {
                this.savingExternalVenomError = "Something went wrong"
            }
            
            this.savingExternalVenom = false;
            
            // Reload the details
            this.loadMonthlyPoolDetails();
        },
        openSession(sessionID) {
            let routeData = this.$router.resolve({name: 'dailyextractionsessionbyid', params: { openSessionID: sessionID }});
            window.open(routeData.href, '_blank');
        },
        async saveAnalysis() {
            this.savingVenomAnalysis = true;

            await VenomPoolingAPI.createUpdateMonthlyPool({
                MonthlyPoolID: this.currentPool.MonthlyPoolID,
                AnalysisComments: this.currentPool.AnalysisComments
            });

            this.savingVenomAnalysis = false; 
        },
        reloadSessions() {
            this.loadMonthlyPoolDetails();
        },
        closePool() {
            this.$refs.closeDialog.showDialog(this.currentPool.MonthlyPoolID)
        }
    },
    created() {
        this.$store.dispatch("speciesStore/loadSpecies");
        this.$store.dispatch("supplierStore/loadSuppliers");
        if (!this.isCreating){
            this.loadMonthlyPool();
        }
    },
    filters: {
        formatDate: function(value) {
            var date = moment(value);
            if (date.isValid){
                return date.format(constants.DATE_FORMAT);
            } else {
                return value;
            }
        },
        formatUserName(email, firstname, surname) {
            if (!email) {
                return "";
            }

            var desc = "";
            if (firstname && firstname != "") {
                desc = firstname;
            }

            if (surname && surname != "") {
                desc += (desc == "" ? "" : " ") + surname;
            }

            desc += (desc == "" ? "" : " (") + email + (desc == "" ? "" : ")");

            return desc;
        },
    }
}
</script>